const defaultConfig = {
  titleKey: "trending_jobs_title",
  itemsKey: "trending_jobs_items",
  buttonVariantKey: "trending_jobs_button_variant",
};

export const trendingJobs = ({ page, config, ...props }) => {
  config = Object.assign({}, defaultConfig, config);

  if (!page || !(config.itemsKey in page) || page[config.itemsKey].length === 0) {
    return null;
  }

  return {
    component: "TrendingJobs",
    props: {
      title: page[config.titleKey] ?? null,
      items: page[config.itemsKey].map((i) => ({
        title: i.title ?? null,
        url: i.url ?? null,
      })),
      buttonVariant: page[config.buttonVariantKey] ?? null,
      ...props,
    },
  };
};
